import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'avatarText',
  standalone: false
})
export class AvatarTextPipe implements PipeTransform {
  transform(value: string): string {
    return !value
      ? '-'
      : value
          .replace(/[^a-zA-ZąčęėįšųūžĄČĘĖĮŠŲŪŽ0-9 ]/g, '')
          .toUpperCase()
          .split(' ')
          .map((s) => s.substring(0, 1))
          .join('')
          .substring(0, 2);
  }
}
